/*==================================================
  HERSHOP CATEGORIES SCROLL ANIMATION
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const section = document.querySelector(".hershop-editorial-categories");

    if (!section) return;

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (entry.isIntersecting) {

                section.classList.add("is-visible");

            } else {

                section.classList.remove("is-visible");

            }

        });

    }, {

        threshold: 0.20,
        rootMargin: "0px 0px -10% 0px"

    });

    observer.observe(section);

});